import { Box, Divider, ListItem, Stack, Typography } from '@mui/material';
import { Campaign } from 'services/campaign/types';
import { TextBlock } from 'common/ui/TextBlock';
import { CampaignQuestionView } from 'pages/CampaignCreation/components/QuestionViews';
import React from 'react';
import { AlertCard, CopyButton } from 'common/ui';
import { buildContentList } from 'modules/campaigns/utils/buildContentList';
import { sortQuestions } from 'modules/campaigns/utils/sortQuestionsDeprecated';

type Props = {
  campaign: Campaign;
};

export const CampaignQuestionsDrawer: React.FC<Props> = ({ campaign }) => {
  const contentList = buildContentList(campaign);

  return (
    <Stack spacing="20px" sx={{ py: '20px' }}>
      <AlertCard type="info" title="Questions cannot be edited once live">
        To send candidates different questions, duplicate this campaign or
        create a new one.
      </AlertCard>

      <TextBlock
        variant="field"
        subtitle={
          <Stack direction="column" gap="20px">
            {(campaign.questions ?? [])
              .slice()
              .sort(sortQuestions)
              .map((question, index) => (
                <Stack key={`question-${index}`} direction="column" gap="30px">
                  <CampaignQuestionView question={question} />
                  <Divider sx={{ color: 'customGrey.light' }} />
                </Stack>
              ))}
          </Stack>
        }
        sx={{
          gap: '20px'
        }}
      />
      {contentList.map((item, index) => (
        <TextBlock
          key={index}
          variant="field"
          title={item.title}
          subtitle={item.content}
          sx={{
            gap: '10px'
          }}
        />
      ))}

      {campaign.outreachDescription && (
        <ListItem sx={{ px: 0 }}>
          <Box>
            <Typography fontWeight="bold">Campaign description</Typography>

            <Box display="flex" alignItems="center" mt={1}>
              <CopyButton
                valuesToCopyFunction={() =>
                  campaign.outreachDescription ?? undefined
                }
              />
            </Box>
          </Box>
        </ListItem>
      )}
    </Stack>
  );
};
